export class CompaniesImpactedsCtrl {
    constructor(locals, $mdDialog) {
        this.locals = locals;
        this.$mdDialog = $mdDialog;
        this.companies = locals.companies;
        this.accounting = locals.accounting;
    }

    $onInit() {
        if (this.accounting.props) this.accounting.setLevelMission();
    }
}

angular
    .module("nucont.shared")
    .controller("CompaniesImpactedsCtrl", [
        "locals",
        "$mdDialog",
        CompaniesImpactedsCtrl
    ]);
